export const AUCTION_STATES = {
  PRE_AUCTION: 0,
  MAIN_AUCTION: 1,
  EXTENDED_BIDDING: 2,
  UPDATING: 3,
  POST_AUCTION: 4
};

export const AUCTION_STATUSES = {
  PREVIEW: 'preview',
  OPEN: 'open',
  EXTENDED: 'extended',
  UPDATING: 'updating',
  CLOSED: 'closed'
};

export const AUCTION_TYPES = {
  EXTENDED: 'extended',
  SALES_HISTORY: 'history',
  WEEKLY: 'weekly',
  FIXED_PRICE: 'vault'
}

export const API_AUCTION_TYPES = {
  extended: 'PREMIER',
  weekly: 'WEEKLY',
  vault: 'FIXED'
}